import {GET_INDUSTRY, UPDATE_INDUSTRY, POST_INDUSTRY} from '../../Constant/ActionTypes';

const initialState = {
  allIndustries: false,
  isUpdateIndustry: false,
  isCreateIndustry: false,
};
const IndustryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INDUSTRY:
      return {
        ...state,
        allIndustries: action.payload,
        isUpdateIndustry: false,
        isCreateIndustry: false,
      };
    case UPDATE_INDUSTRY:
      return {
        ...state,
        isUpdateIndustry: true,
        allIndustries: false,
      };
    case POST_INDUSTRY:
      return {
        ...state,
        isCreateIndustry: true,
        allIndustries: false,
      };
    default:
      return state;
  }
};

export default IndustryReducer;
